import { BaseDTO } from './basedto';

export class ProposalExternalComment extends BaseDTO {
    ProposalId: number;
    UserName: string;
    Comment: string;
    IsByTeslaUser: boolean;
    constructor() {
        super();
    }
}
